/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DailyCost } from '../models/daily-cost';
import { DailyCloudCostDTO } from '../models/daily-cloud-cost-dto';

/**
 * Ui Cloud Cost Explorer Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiCloudCostExplorerControllerService extends __BaseService {
  static readonly isAwsCostExplorerEnabledUsingGETPath =
    '/cc-ui/v1/cost-explorer/aws/enabled';
  static readonly getServiceWiseCostUsingGETPath =
    '/cc-ui/v1/cost-explorer/service-wise-cost/{clusterId}';
  static readonly getDailyCloudCostUsingGETPath =
    '/cc-ui/v1/cost-explorer/stack/{stackName}/daily-cost';
  static readonly syncCloudCostUsingGETPath =
    '/cc-ui/v1/cost-explorer/sync-cost';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * isAwsCostExplorerEnabled
   * @return OK
   */
  isAwsCostExplorerEnabledUsingGETResponse(): __Observable<
    __StrictHttpResponse<boolean>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/cost-explorer/aws/enabled`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * isAwsCostExplorerEnabled
   * @return OK
   */
  isAwsCostExplorerEnabledUsingGET(): __Observable<boolean> {
    return this.isAwsCostExplorerEnabledUsingGETResponse().pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * getServiceWiseCost
   * @param params The `UiCloudCostExplorerControllerService.GetServiceWiseCostUsingGETParams` containing the following parameters:
   *
   * - `start`: start
   *
   * - `end`: end
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getServiceWiseCostUsingGETResponse(
    params: UiCloudCostExplorerControllerService.GetServiceWiseCostUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<DailyCost>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.start != null)
      __params = __params.set('start', params.start.toString());
    if (params.end != null)
      __params = __params.set('end', params.end.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/cost-explorer/service-wise-cost/${encodeURIComponent(
          String(params.clusterId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DailyCost>>;
      }),
    );
  }
  /**
   * getServiceWiseCost
   * @param params The `UiCloudCostExplorerControllerService.GetServiceWiseCostUsingGETParams` containing the following parameters:
   *
   * - `start`: start
   *
   * - `end`: end
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getServiceWiseCostUsingGET(
    params: UiCloudCostExplorerControllerService.GetServiceWiseCostUsingGETParams,
  ): __Observable<Array<DailyCost>> {
    return this.getServiceWiseCostUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<DailyCost>),
    );
  }

  /**
   * getDailyCloudCost
   * @param params The `UiCloudCostExplorerControllerService.GetDailyCloudCostUsingGETParams` containing the following parameters:
   *
   * - `start`: start
   *
   * - `stackName`: stackName
   *
   * - `end`: end
   *
   * - `clusterIds`: clusterIds
   *
   * @return OK
   */
  getDailyCloudCostUsingGETResponse(
    params: UiCloudCostExplorerControllerService.GetDailyCloudCostUsingGETParams,
  ): __Observable<__StrictHttpResponse<DailyCloudCostDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.start != null)
      __params = __params.set('start', params.start.toString());

    if (params.end != null)
      __params = __params.set('end', params.end.toString());
    (params.clusterIds || []).forEach((val) => {
      if (val != null) __params = __params.append('clusterIds', val.toString());
    });
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/cost-explorer/stack/${encodeURIComponent(
          String(params.stackName),
        )}/daily-cost`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DailyCloudCostDTO>;
      }),
    );
  }
  /**
   * getDailyCloudCost
   * @param params The `UiCloudCostExplorerControllerService.GetDailyCloudCostUsingGETParams` containing the following parameters:
   *
   * - `start`: start
   *
   * - `stackName`: stackName
   *
   * - `end`: end
   *
   * - `clusterIds`: clusterIds
   *
   * @return OK
   */
  getDailyCloudCostUsingGET(
    params: UiCloudCostExplorerControllerService.GetDailyCloudCostUsingGETParams,
  ): __Observable<DailyCloudCostDTO> {
    return this.getDailyCloudCostUsingGETResponse(params).pipe(
      __map((_r) => _r.body as DailyCloudCostDTO),
    );
  }

  /**
   * syncCloudCost
   */
  syncCloudCostUsingGETResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/cost-explorer/sync-cost`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * syncCloudCost
   */
  syncCloudCostUsingGET(): __Observable<null> {
    return this.syncCloudCostUsingGETResponse().pipe(
      __map((_r) => _r.body as null),
    );
  }
}

module UiCloudCostExplorerControllerService {
  /**
   * Parameters for getServiceWiseCostUsingGET
   */
  export interface GetServiceWiseCostUsingGETParams {
    /**
     * start
     */
    start: string;

    /**
     * end
     */
    end: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getDailyCloudCostUsingGET
   */
  export interface GetDailyCloudCostUsingGETParams {
    /**
     * start
     */
    start: string;

    /**
     * stackName
     */
    stackName: string;

    /**
     * end
     */
    end: string;

    /**
     * clusterIds
     */
    clusterIds?: Array<string>;
  }
}

export { UiCloudCostExplorerControllerService };
